<div class="rel guts-m-b-3">
  <div class="wrapper">
    <ng-content></ng-content>
    <dgx-tab-navigation
      *ngIf="showSearchTabs"
      [tabList]="tabList$ | async"
      [underlineSelectedTabOnly]="true"
      [wrapperClasses]="'guts-p-v-0 tabnavs--dark-background'"
    ></dgx-tab-navigation>
  </div>
</div>
